<script>
export default {
    props: [
        'accountInfo',
        'method',
        'currency',
        'canxVal',
        'stage',
        'paxNames',
        'passenger'
    ],
    data() {
        return {
            lead: false,
            canxall: false,
            selected: [],
            potentialSelected: [],
            paxNameOptions: [],
            paxNamePotentialOptions: []
        };
    },
    mounted() {
        this.paxNameOptions = this.formatPaxNameOptions()
        this.updatePaxNames()
    },
    methods: {
      formatPaxNameOptions() {
           if (this.paxNames && this.paxNames.length) {
             let mapOptions =  this.paxNames.map((pax) => { if (this.stage === 5 && pax.name.includes(this.passenger.name)) { this.selected.push(pax.name) }; return { text: pax.name, value: pax.name }})
             return mapOptions
           } else {
             return [ { text: 'No Passengers Found', value: '' , disabled: true } ]
           }
      },
      updatePaxNames(){
        this.paxNamePotentialOptions = []
        this.paxNames.forEach((pax) => {
        if (this.selected.includes(pax.name)) {
           this.paxNamePotentialOptions.push({ text: pax.name, value: pax.name, disabled: true })
        } else {
          this.paxNamePotentialOptions.push({ text: pax.name, value: pax.name, disabled: false })
        }
        })
        return this.paxNamePotentialOptions
      },
      proceed() {
        this.$emit('setCancelledTravellers', this.selected)
        this.$emit('setPotentialTravellers', this.potentialSelected)
        if (this.stage === 5) {
          this.$emit('nextStage', 6)
         } else {
          this.$emit('nextStage', 7)
        } 
      }
    }
}
</script>
<template>
  <div class="my-buttons">
    <div class="row-fluid text-center justifiy-content-center">
      <p v-if="stage === 3">
        Do you have the permission to cancel for all clients on the booking?
      </p>
      <span v-if="stage === 3">
        <p
          v-for="(pax, index) in paxNames"
          :key="index"
        >
          <b-icon
            class="icon-check" 
            icon="check-square"
            style="cursor: default;"
          /> {{ pax.name }}
        </p>
      </span>
      <span v-if="stage === 5">
        <b-form-group
          v-slot="{ ariaDescribedby }"
          label="Please select which clients you have permission to cancel on behalf of"
        >
          <b-form-checkbox-group
            id="cbox-passenger"
            v-model="selected "
            stacked
            button-variant="info"
            :options="paxNameOptions"
            :aria-describedby="ariaDescribedby"
            name="passengers-list"
            @change="updatePaxNames"
          />
        </b-form-group>
      </span>
      <span v-if=" stage === 6">
        <b-form-group
          v-slot="{ ariaDescribedby }"
          label="Please select any other clients who have intentions of cancelling. Please note that by selecting them you will not be cancelling on behalf of them."
        >
          <b-form-checkbox-group
            id="cbox-passenger-potential"
            v-model="potentialSelected"
            stacked
            button-variant="info"
            :options="paxNamePotentialOptions"
            :aria-describedby="ariaDescribedby"
            name="passengers-list"
          />
        </b-form-group>
      </span>
    </div>
    <div class="row justify-content-center ">
      <button
        v-if="stage === 3"
        class="btn btn-danger rounded"
        @click="$emit('setAllBooking', false); $emit('nextStage', 5)" 
      >
        No
      </button>
      <button
        v-if="stage === 3"
        class="btn btn-success rounded" 
        @click="$emit('setCancelledTravellers', paxNameOptions.map((pax) => pax.value));$emit('setPotentialTravellers', []); $emit('nextStage', 7)"
      >
        Yes
      </button>
      <button
        v-if="stage === 5 || stage === 6"
        class="btn btn-success rounded" 
        @click="proceed"
      >
        Proceed to next step
      </button>
    </div>
  </div>
</template>
<style>
 .icon-check {
    font-size: large;
    color: green;
    margin-left: 0.5rem;
 }
 .icon-not-check {
    font-size: large;
    color: red;
    margin-left: 0.5rem;
 }
 #cbox-passenger .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #76c95f;
    background-color: #76c95f
}
#cbox-passenger-potential .custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
    color: #76c95f;
    font-weight: 600;
}
 </style>

